<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <template slot="choose_info">
            <selectCom :tabList="tabList" @getTab="getTab" v-if="widgetType == 1"></selectCom>
        </template>
        <div class="widget_cont">
            <div class="class_type" v-if="(widgetType == 1 && activeName == '我主办的') || (widgetType != 1)">
                <div class="count_title" v-if="widgetType == 1">研修统计</div>
                <div class="count_list">
                    <span class="float_right"><span>{{tableData.joinPrepar || 0}}</span>/{{tableData.preparTotal || 0}}</span>
                    <span class="type1_left">协同备课<b v-if="widgetType == 1">：</b></span>
                </div>
                <div class="count_list">
                    <span class="float_right"><span>{{tableData.joinExpertLecture || 0}}</span>/{{tableData.ExpertLectureTotal || 0}}</span>
                    <span class="type1_left">专家讲座<b v-if="widgetType == 1">：</b></span>
                </div>
                <div class="count_list">
                    <span class="float_right"><span>{{tableData.joinAboutReview || 0}}</span>/{{tableData.aboutReviewTotal || 0}}</span>
                    <span class="type1_left">约听评课<b v-if="widgetType == 1">：</b></span>
                </div>
                <div class="count_list">
                    <span class="float_right"><span>{{tableData.joinVideoLesson || 0}}</span>/{{tableData.VideoLessonTotal || 0}}</span>
                    <span class="type1_left">视频课例<b v-if="widgetType == 1">：</b></span>
                </div>
                <div class="count_list">
                    <span class="float_right"><span>{{tableData.joinCumulativeTerm || 0}}</span>/{{tableData.cumulativeTermTotal || 0}}</span>
                    <span class="type1_left">本学期累计<b v-if="widgetType == 1">：</b></span>
                </div>
            </div>
            <!-- <span class="setting_btn"><i class="el-icon-setting"></i>设置目标</span> -->
            <el-tabs v-model="activeName">
                <el-tab-pane label="我的活动" name="我的活动"  v-if="$store.state.permission['NETWORK_WIDGRT_2']">
                    <div class="activity_list second_list" v-for="(join,index) in tableData.takePartIn" :key="index">
                        <img src="../img/widget/ico5.png" v-if="widgetType != 1">
                        <span class="tag" v-if="widgetType == 1">
                                <template v-if="join.organizationType == 1">协同备课</template>
                                <template v-if="join.organizationType == 2">约听评课</template>
                                <template v-if="join.organizationType == 3">专家讲座</template>
                                <template v-if="join.organizationType == 4">视频课例</template>
                        </span>
                        <div class="activity_info">
                            <span class="user_name">{{join.creatorName}}</span>
                            <span>发起</span>
                            <div @click="netWorkJoinDetail('takePartIn',join)">{{join.courseName}}</div>
                            <span class="tag" v-if="widgetType != 1">
                                <template v-if="join.organizationType == 1">协同备课</template>
                                <template v-if="join.organizationType == 2">约听评课</template>
                                <template v-if="join.organizationType == 3">专家讲座</template>
                                <template v-if="join.organizationType == 4">视频课例</template>
                            </span>
                        </div>
                        <div class="activity_time">{{join.beginDate | dateFilter}}
                            <span v-if="join.status == 0" class="status not_beginning">未开始</span>
                            <span v-if="join.status == 1" class="status have_hand">进行中</span>
                            <span v-if="join.status == 2" class="status have_hand">已结束</span>
                            <span v-if="join.status == 3" class="status have_hand">已暂停</span>
                        </div>
                    </div>
                    <div class="noData" v-if="!tableData.takePartIn || tableData.takePartIn.length == 0" style="width:100%"><img src="~css_img/icon_emptypage.png" style="height:150px"></div>
                </el-tab-pane>
                <el-tab-pane label="我组织的活动" name="我组织的活动" v-if="$store.state.permission['NETWORK_WIDGRT_1']">
                    <div class="activity_list" v-for="(join,index) in tableData.myHost" :key="index">
                        <span class="tag float_left">
                            <template v-if="join.organizationType == 1">协同备课</template>
                            <template v-if="join.organizationType == 2">约听课评</template>
                            <template v-if="join.organizationType == 3">专家讲座</template>
                            <template v-if="join.organizationType == 4">视频课例</template>
                        </span>
                        <div class="activity_cont">
                            <div class="activity_title" @click="netWorkDetail('myHost',join)">{{join.courseName}}</div>
                            <div class="activity_about cont_text_overflow" :title="join.joinNum+'人参加'">
                                <span>{{join.beginDate | dateFilter}}开始</span>
                                <span>{{join.joinNum || 0}}人参与</span>
                                <div class="activity_status">
                                    <span v-if="join.stutas == 0" class="not_beginning">未开始</span>
                                    <span v-if="join.stutas == 1" class="have_hand">进行中</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="noData" v-if="!tableData.myHost || tableData.myHost.length == 0" style="width:100%"><img src="~css_img/icon_emptypage.png" style="height:150px"></div>
                </el-tab-pane>
                
            </el-tabs>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        filters:{
            dateFilter:function(val){
                let data = new Date(val)
                let Month = parseInt(data.getMonth()) + 1
                return data.getFullYear() + '-' + Month + '-' + data.getDate() + ' '
            }
        },
        data(){
            return {
                widgetType:1,
                router:'network_index',
                activeName:'我的活动',
                tableData:{},
                tabList:['我的活动','我组织的活动'], 
                activeTab:'',
                color:[
                    ['#10D9D2','#21E8AD'],
                    ['#2582F4','#35A9F9'],
                    ['#F0B41B','#E6DE07'],
                    ['#D335F3','#FF76B4'],
                    ['#26E9A9','#E3E703']
                ]
            }
        },
        mounted(){
            let vm = this
            console.log(this.$store.state.permission)
            vm.$nextTick(function(){
                vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    let widgetUrl = stemp[0].apiUrl
                    vm.query(widgetUrl)
                }
            })
        },
        methods: {
            query(){
                let vm = this
                http.get('/gateway/learning/widget').then(function(xhr){
                    let objectA = xhr.data
                    vm.simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    var newObj = new Object();
                    vm.tableData = widgetFilter.showProps(objectA,'',vm.simpleMap,newObj)
                })
            },
            getTab(data){
                this.activeName = data
            },
            netWorkDetail(type,item){
                let obj = {
                    node:type+',courseName',
                    param:item,
                    breadcrumb:'活动详情'
                }
                let irouter = widgetFilter.nodeSplicing(obj,this.configList,this.simpleMap)
                if(irouter)
                this.$irouter(irouter)
            },
            netWorkJoinDetail(type,item){
                let vm = this
                if(item.status == 1 && item.participate == 1){
                    http.get(`${InterfacePrefix['network']}/activity/${item.courseId}`).then(function(xhr){
                        vm.addParticipation(xhr.data.data)
                    })
                }else{
                    vm.netWorkDetail(type,item)
                }
            },
            addParticipation(activity) {
                let vm = this;
                if (activity.message) {
                    vm.$message.warning(activity.message);
                    return;
                }
                http.post(InterfacePrefix["network"] + "/activityInfo/addParticipation/" + activity.id).then(function(xhr) {
                    if (xhr.data.code) return;
                    let breadcrumb = [{ name: "参与活动", component: "network_activity_partin" }];
                    if (activity.activityId) {
                    breadcrumb.unshift({ name: "专题详情", component: "network_topic_info" });
                    }
                    if (activity.onlineStatus === 2) {
                    vm.$irouter({
                        name: "network_activity_partin",
                        param: { activity: activity, breadcrumb: breadcrumb }
                    });
                    } else {
                    //  组织形式 0 无 1  协同备课 2 约听评课 3 专家讲座 4 视频课例
                    switch (activity.organizationType) {
                        case 1:
                        vm.$irouter({
                            name: "network_activity_partin",
                            param: { activity: activity, breadcrumb: breadcrumb }
                        });
                        break;
                        case 2:
                        let appointment = xhr.data.data;
                        appointment.lesson = vm.showLesson(
                            appointment.day,
                            appointment.lesson
                        );
                        vm.$irouter({
                            name: "network_activity_partin", param: {
                            activity: activity,
                            appointment: appointment,
                            breadcrumb: breadcrumb
                            }
                        });
                        break;
                        case 3:
                        activity.roomId = xhr.data.data;
                        vm.$irouter({
                            name: "network_activity_partin",
                            param: { activity: activity, breadcrumb: breadcrumb }
                        });
                        break;
                        case 4:
                        vm.$irouter({
                            name: "network_activity_partin",
                            param: { activity: activity, breadcrumb: breadcrumb }
                        });
                        break;
                        default:
                        console.warn("未知的活动组织类型:", activity.organizationType);
                        vm.$message.warning("未知的活动组织类型!");
                    }
                    }

                });
            }
        }
    }
</script>
<style scoped lang="less">
    .widget_cont{
        height: 280px;
        overflow: hidden;
        position: relative;
        .setting_btn{
            position: absolute;top: 95px;right:0;
            color: #4183fc;
            i{
                margin-right: 8px;
            }
        }
    }
    .phone_weight{
        .class_type{
            text-align: center;
            .list{
                margin: 0 5px;
                padding: 8px 4px;
            }
            .float_right{
                float: none;
            }
        }
    }
    .widget_level3,
    .widget_level2{
        .class_type{
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            margin-top: 10px;
            .count_list{
                flex-grow: 1;
                margin: 0 10px;
                height: 74px;
                color:#fff;
                border-radius:5px;
                padding:16px 22px;
                box-sizing:border-box;
                &>span{
                    font-size: 12px;
                    span{
                        font-size:36px;
                    }
                }
            }
            .count_list:first-child{
                margin-left: 0;
            }
            .count_list:last-child{
                margin-right: 0;
            }
        }
        .activity_status{
            margin-top: 4px;
        }
        .activity_list:nth-child(2n+1){
            padding-right: 20px;
        }
        .activity_list:nth-child(2n+2){
            padding-left: 20px;
        }
        .second_list{
            margin: 25px 0 10px 0;
        }
    }
    .widget_level3{
        .count_list:nth-child(1){
            background:url(../img/widget/ico1.png) no-repeat left,linear-gradient(to right,#2582F4,#35A9F9);
            background:url(../img/widget/ico1.png) no-repeat left,-webkit-linear-gradient(to right,#2582F4,#35A9F9);
            background:url(../img/widget/ico1.png) no-repeat left,-o-linear-gradient(to right,#2582F4,#35A9F9);
            background:url(../img/widget/ico1.png) no-repeat left,-moz-linear-gradient(to right,#2582F4,#35A9F9);
            background: url(../img/widget/ico1.png) no-repeat left,linear-gradient(to right,#2582F4,#35A9F9);
        }
        .count_list:nth-child(2){
            background:url(../img/widget/ico2.png) no-repeat left,linear-gradient(to right,#10D9D2,#21E8AD);
            background:url(../img/widget/ico2.png) no-repeat left,-webkit-linear-gradient(to right,#10D9D2,#21E8AD);
            background:url(../img/widget/ico2.png) no-repeat left,-o-linear-gradient(to right,#10D9D2,#21E8AD);
            background:url(../img/widget/ico2.png) no-repeat left,-moz-linear-gradient(to right,#10D9D2,#21E8AD);
            background: url(../img/widget/ico2.png) no-repeat left,linear-gradient(to right,#10D9D2,#21E8AD);
        }
        .count_list:nth-child(3){
            background:url(../img/widget/ico3.png) no-repeat left,linear-gradient(to right,#F0B41B,#E6DE07);
            background:url(../img/widget/ico3.png) no-repeat left,-webkit-linear-gradient(to right,#F0B41B,#E6DE07);
            background:url(../img/widget/ico3.png) no-repeat left,-o-linear-gradient(to right,#F0B41B,#E6DE07);
            background:url(../img/widget/ico3.png) no-repeat left,-moz-linear-gradient(to right,#F0B41B,#E6DE07);
            background: url(../img/widget/ico3.png) no-repeat left,linear-gradient(to right,#F0B41B,#E6DE07);
        }
        .count_list:nth-child(4){
            background:url(../img/widget/ico4.png) no-repeat left,linear-gradient(to right,#D335F3,#FF76B4);
            background:url(../img/widget/ico4.png) no-repeat left,-webkit-linear-gradient(to right,#D335F3,#FF76B4);
            background:url(../img/widget/ico4.png) no-repeat left,-o-linear-gradient(to right,#D335F3,#FF76B4);
            background:url(../img/widget/ico4.png) no-repeat left,-moz-linear-gradient(to right,#D335F3,#FF76B4);
            background: url(../img/widget/ico4.png) no-repeat left,linear-gradient(to right,#D335F3,#FF76B4);
        }
        .count_list:nth-child(5){
            background:url(../img/widget/ico5.png) no-repeat left,linear-gradient(to right,#26E9A9,#E3E703);
            background:url(../img/widget/ico5.png) no-repeat left,-webkit-linear-gradient(to right,#26E9A9,#E3E703);
            background:url(../img/widget/ico5.png) no-repeat left,-o-linear-gradient(to right,#26E9A9,#E3E703);
            background:url(../img/widget/ico5.png) no-repeat left,-moz-linear-gradient(to right,#26E9A9,#E3E703);
            background: url(../img/widget/ico5.png) no-repeat left,linear-gradient(to right,#26E9A9,#E3E703);
        }
    }
    .widget_level2{
        .count_list:nth-child(1){
            background:linear-gradient(#2582F4,#35A9F9);
            background:-webkit-linear-gradient(#2582F4,#35A9F9);
            background:-o-linear-gradient(#2582F4,#35A9F9);
            background:-moz-linear-gradient(#2582F4,#35A9F9);
        }
        .count_list:nth-child(2){
            background:linear-gradient(#10D9D2,#21E8AD);
            background:-webkit-linear-gradient(#10D9D2,#21E8AD);
            background:-o-linear-gradient(#10D9D2,#21E8AD);
            background:-moz-linear-gradient(#10D9D2,#21E8AD);
        }
        .count_list:nth-child(3){
            background:linear-gradient(#F0B41B,#E6DE07);
            background:-webkit-linear-gradient(#F0B41B,#E6DE07);
            background:-o-linear-gradient(#F0B41B,#E6DE07);
            background:-moz-linear-gradient(#F0B41B,#E6DE07);
        }
        .count_list:nth-child(4){
            background:linear-gradient(#D335F3,#FF76B4);
            background:-webkit-linear-gradient(#D335F3,#FF76B4);
            background:-o-linear-gradient(#D335F3,#FF76B4);
            background:-moz-linear-gradient(#D335F3,#FF76B4);
        }
        .count_list:nth-child(5){
            background:linear-gradient(#26E9A9,#E3E703);
            background:-webkit-linear-gradient(#26E9A9,#E3E703);
            background:-o-linear-gradient(#26E9A9,#E3E703);
            background:-moz-linear-gradient(#26E9A9,#E3E703);
        }
        .class_type{
            .count_list{
                padding: 6px;
                text-align: center;
                &>span{
                    display: block;
                }
                .float_right{
                    float: none;
                }
            }
        }
    }
    .widget_level1{
        .class_type{
            background:linear-gradient(#3BB7FB,#1965F0);
            background:-webkit-linear-gradient(#3BB7FB,#1965F0);
            background:-o-linear-gradient(#3BB7FB,#1965F0);
            background:-moz-linear-gradient(#3BB7FB,#1965F0);
            color:#fff;
            border-radius: 5px;
            padding:15px 20px;
            display:flex;
            flex-wrap: wrap;
            margin:18px 0 6px 0;
        }
        .count_list{
            min-width: 50%;
            margin-top: 5px;
            font-size: 12px;
        }
        .float_right{
            float: none;
            span{
                font-weight: bold;
            }
        }
        .type1_left{
            float: left;
        }
        .count_title{
            font-size: 14px;
            width: 100%;
            margin-bottom: 5px;
        }
        .activity_cont{
            margin-bottom: 22px;
        }
        .activity_list{
            display: block;
            padding-right: 0;
            width: auto;
        }
        .activity_status{
            display: inline-block;
            float: right;
        }
        .second_list{
            margin-top: 26px;
            .tag{
                float: left;
            }
            .activity_info,
            .activity_time{
               margin-left: 85px;
            }
            .activity_time{
                margin-top: 4px;
            }
            .status{
                float: right;
            }
        }
    }
    .float_left{
        float: left;
    }
    .activity_list{
            clear: both;
            margin-top: 15px;
            width: 50%;
            box-sizing: border-box;
            display: inline-block;
            vertical-align: top;
            .tag{
                background: #EDF3FE;
                border-radius: 2px;
                padding: 1px 10px;
                display: inline-block;
                vertical-align: top;
            }
            img{
                float: left;
                width: 36px;
                height: 36px;
                border-radius:50%;
                margin-right:10px;
            }
            .activity_info{
                display: flex;
                flex-wrap: nowrap;
                span{
                    flex-shrink: 0;
                    padding-right:6px;
                }
                .user_name{
                    color: #4183fc;
                }
                div{
                    color: #333;
                    font-weight: bold;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                    cursor: pointer;
                }
            }
            .activity_time{
                color: #999;
                font-size: 12px;
                margin-top: 2px;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
            }
            .not_beginning{color: #DA9C23;}
            .have_hand{color: #1EC698;}
            .activity_cont{
                margin-left: 85px;
                .activity_title{
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                    color:#333;
                    line-height:22px;
                    font-weight:bold;
                    cursor:pointer;
                }
                .activity_about{
                    font-size: 12px;
                    color: #666;
                    margin-top: 2px;
                    &>span{
                        margin-right:15px;
                    }
                }
            }
        }
</style>
<style lang="less">
    .widget_cont{
        .el-tabs__header{
            margin-bottom: 0;
        }
    }
    .widget_level1{
        .el-tabs__header{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/network.vue